import { useContext, useMemo } from 'react';
import { markets } from '../data/markets.esm.js';
import { AppContext } from '../components/context/context.esm.js';

var useMarket = function() {
    var _useContext = useContext(AppContext), tmp = _useContext.market, _ref = tmp === void 0 ? {
        code: markets[0].countryCode,
        disabled: false
    } : tmp, code = _ref.code, disabled = _ref.disabled, onMarketChange = _useContext.onMarketChange;
    var market = useMemo(function() {
        return markets.find(function(param) {
            var countryCode = param.countryCode;
            return countryCode.toUpperCase() === (code === null || code === void 0 ? void 0 : code.toUpperCase());
        }) || markets[0];
    }, [
        code
    ]);
    return {
        market: market,
        disabled: disabled,
        onMarketChange: onMarketChange
    };
};

export { useMarket };
